(() => {
  "use strict";

  document.getElementById("onCheck").addEventListener("click", () => {
    const high = document.getElementById("high");
    const middle = document.getElementById("middle");
    const low = document.getElementById("low");

    high.style.display = "none";
    middle.style.display = "none";
    low.style.display = "none";

    // チェックされている input[type=checkbox] を全部取得
    const checkedCount = document.querySelectorAll("#checklist input[type=checkbox]:checked").length;
    if (checkedCount > 0) {
      // 結果表示エリアを出す
      const resultEl = document.querySelector(".transferEccube__riskCheck__result");
      resultEl.style.display = "block";
      const loading = document.querySelector(".transferEccube__loading");
      loading.style.display = "block";

      const results = () => {
        loading.style.display = "none";
        //結果
        if (checkedCount >= 8) {
          high.style.display = "block";
        } else if (checkedCount >= 4) {
          middle.style.display = "block";
        } else {
          low.style.display = "block";
        }
      };

      setTimeout(results, 3000);
    } else {
      document.querySelector(".transferEccube__riskCheck__result").style.display = "none";
    }
  });
})();
